document.addEventListener("DOMContentLoaded", function () {
  var filterHeading = document.querySelector(".sp-category-filter__heading");
  var filterContent = document.querySelector(".sp-category-filter__content");

  // クリックイベントハンドラーを追加して開閉機能を実装
  filterHeading.addEventListener("click", function () {
    var expanded = this.getAttribute("aria-expanded") === "true";
    this.setAttribute("aria-expanded", !expanded);
    filterContent.style.display = expanded ? "none" : "block"; // コンテンツの表示を切り替え
  });
});

// SP絞り込み
document.addEventListener("DOMContentLoaded", function () {
  const filterSidebar = document.getElementById("filter-sidebar");
  const filterTrigger = document.getElementById("filter-trigger");
  const filterClose = document.querySelector(".filter-sidebar-close");
  const filterForm = document.getElementById("filter-form");
  const checkboxes = filterForm.querySelectorAll(".checkbox-input");
  const resetButton = document.querySelector(".btn-reset-filter");
  const filterOverlay = document.querySelector(".filter__overlay");
  const unselectedCheckbox = document.querySelector(".btn-apply-filter");
  const body = document.body;

  // サイドバーとオーバーレイを表示する
  filterTrigger.addEventListener("click", function () {
    filterSidebar.classList.add("filter-sidebar-active");
    filterOverlay.classList.add("filter-overlay-active"); // オーバーレイを表示
    body.classList.add("no-scroll");
  });

  // サイドバーとオーバーレイを非表示にする関数
  function closeSidebarAndOverlay() {
    filterSidebar.classList.remove("filter-sidebar-active");
    filterOverlay.classList.remove("filter-overlay-active"); // オーバーレイを非表示
    body.classList.remove("no-scroll");
  }
  // サイドバーの閉じるボタンとオーバーレイのクリックで閉じる
  filterClose.addEventListener("click", closeSidebarAndOverlay);
  filterOverlay.addEventListener("click", closeSidebarAndOverlay);

  // URLのクエリパラメータから現在のタグを取得してチェックボックスを設定
  const currentTag = new URLSearchParams(window.location.search).get("tag");
  if (currentTag) {
    checkboxes.forEach((checkbox) => {
      if (checkbox.value === currentTag) {
        checkbox.checked = true;
      }
    });
  }

  // チェックボックスの選択を一つに限定する処理
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", function () {
      checkboxes.forEach(function (other) {
        if (other !== checkbox) other.checked = false;
      });
    });
  });

  // リセットボタンの処理
  resetButton.addEventListener("click", function () {
    checkboxes.forEach((checkbox) => (checkbox.checked = false));
    window.location.href = unselectedCheckbox.value;
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const filterForm = document.getElementById("filter-form");
  const checkboxes = filterForm.querySelectorAll(".checkbox-input");

  // チェックボックスの選択を一つに限定
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", function () {
      checkboxes.forEach(function (other) {
        if (other !== checkbox) other.checked = false;
      });
    });
  });

  // 絞り込みフォームの送信処理
  filterForm.addEventListener("submit", function (e) {
    e.preventDefault();
    const selectedCheckbox = document.querySelector(".checkbox-input:checked");
    const unselectedCheckbox = document.querySelector(".btn-apply-filter");
    // 選択されたチェックボックスがある場合、そのvalueに含まれるURLに遷移
    if (selectedCheckbox) {
      window.location.href = selectedCheckbox.value;
    } else {
      window.location.href = unselectedCheckbox.value;
    }
  });
});
